"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Input = _interopRequireDefault(require("./Input"));
var _InputSt = require("./Input.st.css");
var _DataAttr = _interopRequireDefault(require("./DataAttr"));
var _filterObject = require("../utils/filterObject");
var _WixStyleReactDefaultsOverrideProvider = require("../WixStyleReactDefaultsOverrideProvider");
var _context = require("../WixStyleReactProvider/context");
var _StatusContext = require("../FormField/StatusContext");
var _jsxFileName = "/home/builduser/work/b60d7defec63c7cc/packages/wix-style-react/dist/cjs/Input/ThemedInput.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
class ThemedInput extends _Input.default {
  constructor() {
    super(...arguments);
    // For testing purposes only
    this._getDataAttr = _ref => {
      var {
        statusContext
      } = _ref;
      var {
        input: inputPropsDefaults
      } = this.context;
      var {
        size = inputPropsDefaults.size,
        status,
        prefix,
        disabled,
        forceHover,
        forceFocus,
        noLeftBorderRadius,
        noRightBorderRadius
      } = this.props;
      return (0, _filterObject.filterObject)({
        [_DataAttr.default.SIZE]: size,
        [_DataAttr.default.STATUS]: (0, _StatusContext.getStatusFromContext)(statusContext, status),
        [_DataAttr.default.PREFIX]: !!prefix,
        [_DataAttr.default.DISABLED]: !!disabled,
        [_DataAttr.default.HOVER]: !!forceHover,
        [_DataAttr.default.FOCUS]: !!(forceFocus || this.state.focus),
        [_DataAttr.default.LEFTBORDERRADIUS]: !!noLeftBorderRadius,
        [_DataAttr.default.RIGHTBORDERRADIUS]: !!noRightBorderRadius
      }, (key, value) => !!value);
    };
  }
  render() {
    var {
      input: inputPropsDefaults
    } = this.context;
    var {
      size = inputPropsDefaults.size,
      dataHook,
      rtl,
      status,
      disabled,
      forceHover,
      forceFocus,
      border,
      className,
      noLeftBorderRadius,
      noRightBorderRadius,
      readOnly
    } = this.props;
    var placeholder = this.props.placeholder;
    return /*#__PURE__*/_react.default.createElement(_context.WixStyleReactContext.Consumer, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 65,
        columnNumber: 7
      }
    }, _ref2 => {
      var {
        newColorsBranding
      } = _ref2;
      return /*#__PURE__*/_react.default.createElement(_StatusContext.StatusContext.Consumer, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 67,
          columnNumber: 11
        }
      }, statusContext => /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
        className: (0, _InputSt.st)(_InputSt.classes.root, {
          size,
          hasFocus: forceFocus || this.state.focus,
          status: (0, _StatusContext.getStatusFromContext)(statusContext, status),
          forceHover,
          readOnly,
          disabled,
          border,
          noRightBorderRadius,
          noLeftBorderRadius,
          newColorsBranding
        }, className),
        dir: rtl ? 'rtl' : null,
        "data-hook": dataHook
      }, this._getDataAttr({
        statusContext
      }), {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 69,
          columnNumber: 15
        }
      }), super.render({
        placeholder
      })));
    });
  }
}
ThemedInput.contextType = _WixStyleReactDefaultsOverrideProvider.WixStyleReactDefaultsOverrideContext;
ThemedInput.propTypes = _objectSpread({}, _Input.default.propTypes);
var _default = exports.default = ThemedInput;
//# sourceMappingURL=ThemedInput.js.map